<template>
  <main class="printable-reward-link-redemption-page">
    <printable-reward-link-redemption-header
      :landing-page-customization="landingPageCustomization"
    />
    <printable-reward-link-redemption-page-main-section
      :form-is-loading="isLoading"
      :error-message="errorMessage"
      :landing-page-customization="landingPageCustomization"
      @submit="redeemCode"
    />
    <div>
      <footer-component id="footer" />
    </div>
  </main>
</template>

<script>
import PrintableRewardLinkRedemptionHeader from './PrintableRewardLinkRedemptionHeader'
import PrintableRewardLinkRedemptionPageMainSection from './PrintableRewardLinkRedemptionPageMainSection'
import FooterComponent from '@/components/footer/Footer'
import { LandingPageCustomization } from '../customization/LandingPageCustomization'
import { PRINTED_CODE_ENTERED } from '@/plugins/segment/SegmentConstants'
import { PrintableApi } from '@/cowboy/printable/PrintableApi'

export default {
  name: 'PrintableRewardLinkRedemptionPage',
  components: {
    PrintableRewardLinkRedemptionPageMainSection,
    PrintableRewardLinkRedemptionHeader,
    FooterComponent
  },
  props: {
    landingPageCustomization: {
      type: LandingPageCustomization,
      required: false,
      default: null
    }
  },
  data: () => ({
    isLoading: false,
    errorMessage: ''
  }),
  methods: {
    async redeemCode ({ code: printedCode, captchaToken }) {
      this.isLoading = true
      this.errorMessage = ''
      try {
        const redeemedResponse = (await PrintableApi.redeem(printedCode, captchaToken)).toJSON()
        if (!redeemedResponse?.url) {
          throw new Error('Received response but url returned was not valid')
        }
        this.$segment.track(PRINTED_CODE_ENTERED, { successful: true })
        const pattern = new RegExp(/\?.+=.*/g)
        if (pattern.test(redeemedResponse.url)) {
          window.location.replace(redeemedResponse.url + '&isPrintable=true')
        } else {
          window.location.replace(redeemedResponse.url + '?isPrintable=true')
        }
      } catch (error) {
        const allowedErrorCodes = [404, 400]
        if (
          error &&
          error.response &&
          allowedErrorCodes.includes(error.response.status)
        ) {
          this.$segment.track(PRINTED_CODE_ENTERED, { successful: false })
          this.errorMessage = this.$t('error-incorrect-printable-code')
        } else {
          this.errorMessage = this.$t('printable.errors.unexpectedError')
        }
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.printable-reward-link-redemption-page {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
#footer {
  text-align: center;
  &.row {
    margin-left: 0;
    margin-right: 0;
  }
}
</style>

<style>
html,
body {
  height: 100%;
  width: 100%;
  overflow: visible;
}
</style>
